export default {
  RSU_RECORD(state, payload) {
    state.RSUData = payload;
  },
  SET_DB_DATA(state, payload) {
    state.DBData = payload;
  },
  SET_STORAGE_DATA(state, payload) {
    state.storageData = payload;
  },
};
